import { ChevronLeft, ChevronRight } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'
import { Autoplay, Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import Container from './container'
import 'swiper/css'
import 'swiper/css/navigation'

export default function Clientes() {
  const [mousePosition, setMousePosition] = useState({ x: 50, y: 50 })
  const swiperRef = useRef(null)
  const [activeSlide, setActiveSlide] = useState(0)
  const [totalSlides, setTotalSlides] = useState(0)
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 640

  const parceiros = [
    {
      src: '../assets/clientes/ADAPTI.png',
      alt: 'ADAPTI',
    },
    {
      src: '../assets/clientes/ARREZO.png',
      alt: 'ARREZO',
    },
    {
      src: '../assets/clientes/ENERGISA.png',
      alt: 'ENERGISA',
    },
    {
      src: '../assets/clientes/GABSTER.png',
      alt: 'GABSTER',
    },
    {
      src: '../assets/clientes/GRSA.png',
      alt: 'GRSA',
    },
    {
      src: '../assets/clientes/MERCANTIL.png',
      alt: 'MERCANTIL',
    },
    {
      src: '../assets/clientes/MUEVY.png',
      alt: 'MUEVY',
    },
    {
      src: '../assets/clientes/PERRUZZO.png',
      alt: 'PERRUZZO',
    },
    {
      src: '../assets/clientes/PESTANA.png',
      alt: 'PESTANA',
    },
    {
      src: '../assets/clientes/SELCO.png',
      alt: 'SELCO',
    },
    {
      src: '../assets/clientes/SODEXO.png',
      alt: 'SODEXO',
    },
    {
      src: '../assets/clientes/TERMOLAR.png',
      alt: 'TERMOLAR',
    },
    {
      src: '../assets/clientes/TERMOMECANICA.png',
      alt: 'TERMOMECANICA',
    },
    {
      src: '../assets/clientes/UNIFIQUE.png',
      alt: 'UNIFIQUE',
    },
    {
      src: '../assets/clientes/VIRTUEYES.png',
      alt: 'VIRTUEYES',
    },
    {
      src: '../assets/clientes/ZALLPY.png',
      alt: 'ZALLPY',
    },
  ]

  const getSlidesPerView = () => {
    if (typeof window !== 'undefined') {
      if (window.innerWidth < 640) return 1
      if (window.innerWidth < 1024) return 2
      return 3
    }
    return 3
  }

  const [slidesPerView, setSlidesPerView] = useState(getSlidesPerView())

  const handleSlideChange = swiper => {
    setActiveSlide(swiper.realIndex)
  }

  const goToSlide = index => {
    if (swiperRef.current?.swiper) {
      swiperRef.current.swiper.slideTo(index)
    }
  }

  useEffect(() => {
    const handleResize = () => {
      setSlidesPerView(getSlidesPerView())
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    setTotalSlides(parceiros.length)
  }, [parceiros.length])

  return (
    <div
      className="relative bg-[#040116] overflow-hidden"
      onMouseMove={e => {
        const rect = e.currentTarget.getBoundingClientRect()
        const x = ((e.clientX - rect.left) / rect.width) * 100
        const y = ((e.clientY - rect.top) / rect.height) * 100
        setMousePosition({ x, y })
      }}
    >
      <Container className="py-16">
        <div
          className="absolute inset-0 pointer-events-none transition-all duration-300 ease-out"
          style={{
            background: `radial-gradient(1200px circle at ${mousePosition.x}% ${mousePosition.y}%, rgba(29, 78, 216, 0.3), transparent 40%)`,
            filter: 'blur(10px)',
          }}
        />
        <div
          className="absolute inset-0 pointer-events-none transition-all duration-300 ease-out opacity-50"
          style={{
            background: `radial-gradient(800px circle at ${mousePosition.x}% ${mousePosition.y}%, rgba(29, 78, 216, 0.3), transparent 40%)`,
          }}
        />
        <Container className="relative z-10">
          <h1 className="font-inter-light text-white text-2xl md:text-4xl text-center">
            Parceiros que confiam em nossas soluções
          </h1>
          <div className="mt-6 md:mt-18">
            <div className="mt-12 md:mt-24 relative certificados-carousel">
              <Swiper
                ref={swiperRef}
                modules={[Navigation, Autoplay]}
                spaceBetween={30}
                slidesPerView={slidesPerView}
                slidesPerGroup={1}
                navigation={!isMobile}
                loop={false}
                autoplay={{
                  delay: 3000,
                  disableOnInteraction: false,
                }}
                onSlideChange={swiper => handleSlideChange(swiper)}
                onInit={swiper => {
                  setActiveSlide(swiper.realIndex)
                }}
                className="mySwiper px-8"
                style={{
                  '--swiper-navigation-color': '#fff',
                  '--swiper-navigation-size': '18px',
                  '--swiper-navigation-sides-offset': '0px',
                }}
              >
                {parceiros.map((cliente, index) => (
                  <SwiperSlide key={index}>
                    <div className="flex items-center justify-center h-[70px] px-8">
                      <img
                        src={cliente.src}
                        alt={cliente.alt}
                        className="max-h-full max-w-full object-cover"
                      />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>

              <div className="flex justify-center mt-8 gap-4">
                <button
                  type="button"
                  onClick={() => {
                    const prevIndex =
                      (activeSlide - 1 + totalSlides) % totalSlides
                    goToSlide(prevIndex)
                  }}
                  className="md:hidden"
                >
                  <ChevronLeft className="text-white" />
                </button>
                <div className="flex flex-row gap-3 items-center">
                  {Array.from({ length: 3 }).map((_, i) => {
                    const isActive =
                      Math.floor(activeSlide / Math.ceil(totalSlides / 3)) === i

                    const isThirdDot = i === 2

                    return (
                      <div
                        key={i}
                        onClick={() => {
                          goToSlide(i * Math.ceil(totalSlides / 3))
                        }}
                        className={`h-1.5 rounded-full cursor-pointer transition-all duration-300 ${
                          isActive
                            ? isThirdDot
                              ? 'w-[6px] bg-transparent border border-white'
                              : 'w-[20px] bg-transparent border border-white'
                            : isThirdDot
                              ? 'w-[6px] bg-white'
                              : 'w-[20px] bg-white'
                        }`}
                        aria-label={`Go to group ${i + 1}`}
                      />
                    )
                  })}
                </div>
                <button
                  type="button"
                  onClick={() => {
                    const nextIndex = (activeSlide + 1) % totalSlides
                    goToSlide(nextIndex)
                  }}
                  className="md:hidden"
                >
                  <ChevronRight className="text-white" />
                </button>
              </div>
            </div>
          </div>
        </Container>
      </Container>
    </div>
  )
}